module.exports = __webpack_public_path__ + "img/contact.8307c4f1.png";